<h1>AGENTS: </h1>

<div class="indicator">
  <div class="available" [style.flex-grow]="available + 1">{{available}}</div>
  <div class="not-available" [style.flex-grow]="notAvailable + 1">{{notAvailable}}</div>
  <div class="out-of-office" [style.flex-grow]="outOfOffice + 1">{{outOfOffice}}</div>
</div>

<div class="time">{{ currentDate$ | async }}</div>